// ROO2-295: the View by rule of the BI reports with company groups (Segmentation, its Property comparison, Channels). Groups
// (the default) or the single items (the PMS segments of Segmentation, the channels of Channels). The browser keeps the
// choice per report (Greg, 2026-10-28, P7).
export type BiView = 'GROUPS' | 'SINGLE';

const isView = (value: unknown): value is BiView => value === 'GROUPS' || value === 'SINGLE';

// The stored choice: a value that is not a view, no value, or a read that fails (a private window) gives Groups.
export const storedView = (read: () => unknown): BiView => {
	try {
		const stored = read();
		return isView(stored) ? stored : 'GROUPS';
	} catch {
		return 'GROUPS';
	}
};

// With no group, the report shows the single items, whatever the choice (the tab Groups is off); the choice stays stored.
export const shownView = (chosen: BiView, hasGroups: boolean): BiView => hasGroups ? chosen : 'SINGLE';
